// src/components/tables/RecentMoneyTable.js — WITH REMARKS
import React, { useEffect, useState } from "react";
import { client } from "../../sanityClient";
import { formatDateBS } from "../../utils/dateUtils";
import { useNavigate } from "react-router-dom";
import "./RecentTable.css";

export default function RecentMoneyTable() {
    const [transactions, setTransactions] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        client
            .fetch(
                `*[_type == "moneyTransaction"] | order(date desc) [0...5] {
          _id, givenOrTaken, amount, date, remarks, user->{username}
        }`
            )
            .then(setTransactions);
    }, []);

    return (
        <div className="recent-table-wrapper">
            <h6 className="recent-table-title text-center">Recent Money Transactions</h6>
            <table className="recent-table">
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>User</th>
                        <th>Amount (₹)</th>
                        <th>Date</th>
                        <th>Remarks</th>   {/* NOW INCLUDED */}
                    </tr>
                </thead>
                <tbody>
                    {transactions.length === 0 ? (
                        <tr>
                            <td colSpan="5" className="text-center py-4 text-muted">
                                No transactions
                            </td>
                        </tr>
                    ) : (
                        transactions.map((t) => (
                            <tr key={t._id}>
                                <td>
                                    <span
                                        className={`badge ${t.givenOrTaken === "Debit" ? "badge-debit" : "badge-credit"
                                            }`}
                                    >
                                        {t.givenOrTaken}
                                    </span>
                                </td>
                                <td>{t.user?.username || "-"}</td>
                                <td>{t.amount.toLocaleString()}</td>
                                <td>{formatDateBS(t.date)}</td>
                                <td>{t.remarks || "-"}</td>   {/* SHOW REMARKS */}
                            </tr>
                        ))
                    )}
                </tbody>
            </table>

            <div className="text-center mt-3">
                <button className="view-all-btn" onClick={() => navigate("/money")}>
                    View All →
                </button>
            </div>
        </div>
    );
}